import React, { FC, ReactElement } from 'react'
import { ServerErrorOptions } from '../../Types/Types'
import Heading from '../Heading'
import Icon from '../Icon'
import { IconSize } from '../../../../NonReact/constants/React/Icon/Constants'

type ServerErrorProps = {
    serverError: ServerErrorOptions[] | string | ReactElement
}

export const ServerError: FC<ServerErrorProps> = (props: ServerErrorProps): ReactElement => {
    const { serverError } = props

    return (
        <div className='error-container'>
            {Array.isArray(serverError)
                ? serverError.map(
                      (
                          { className, icon, headingLevel, title, message }: ServerErrorOptions,
                          index: number
                      ): ReactElement => (
                          <div key={`${index}-${title}-${message}`} className={className}>
                              <Icon iconName={icon.name} iconSize={IconSize.LARGE} />
                              <div>
                                  <Heading level={headingLevel}>{title}</Heading>
                                  <p>{message}</p>
                              </div>
                          </div>
                      )
                  )
                : { serverError }}
        </div>
    )
}
